Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = require('./lib');
exports.connect = require('react-redux').connect;



//////////////////
// WEBPACK FOOTER
// ./~/dva/index.js
// module id = 26
// module chunks = 0